import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  updateAvatarStatus: '',
  deleteAvatarStatus: '',

  personalData: {},
  updatePersonalDataStatus: '',

  financialData: {},
  updateFinancialDataStatus: '',

  updatePasswordStatus: '',
  update2FaStatus: '',

  uploadDocumentStatus: '',
  verifyDocumentStatus: '',
  documents: [],
  sumsubParams: {},

  authLogs: [],
};

export const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    setProfileUpdateAvatarStatus: (state, action) => {
      state.updateAvatarStatus = action.payload;
    },
    setProfileDeleteAvatarStatus: (state, action) => {
      state.deleteAvatarStatus = action.payload;
    },

    setProfilePersonalData: (state, action) => {
      state.personalData = action.payload;
    },
    setProfileUpdatePersonalDataStatus: (state, action) => {
      state.updatePersonalDataStatus = action.payload;
    },

    setProfileFinancialData: (state, action) => {
      state.financialData = action.payload;
    },
    setProfileUpdateFinancialDataStatus: (state, action) => {
      state.updateFinancialDataStatus = action.payload;
    },

    setProfileUpdatePasswordStatus: (state, action) => {
      state.updatePasswordStatus = action.payload;
    },
    setProfileUpdate2FaStatus: (state, action) => {
      state.update2FaStatus = action.payload;
    },

    setProfileUploadDocumentStatus: (state, action) => {
      state.uploadDocumentStatus = action.payload;
    },
    setProfileVerifyDocumentStatus: (state, action) => {
      state.verifyDocumentStatus = action.payload;
    },
    setProfileDocuments: (state, action) => {
      state.documents = action.payload;
    },
    setSumsubParams: (state, action) => {
      state.sumsubParams = action.payload;
    },

    setProfileAuthLogs: (state, action) => {
      state.authLogs = action.payload;
    },

    resetProfile: () => initialState,
  },
});

export const {
  setProfileUpdateAvatarStatus,
  setProfileDeleteAvatarStatus,

  setProfilePersonalData,
  setProfileUpdatePersonalDataStatus,

  setProfileFinancialData,
  setProfileUpdateFinancialDataStatus,

  setProfileUpdatePasswordStatus,
  setProfileUpdate2FaStatus,

  setProfileUploadDocumentStatus,
  setProfileVerifyDocumentStatus,
  setProfileDocuments,
  setSumsubParams,

  setProfileAuthLogs,

  resetProfile,
} = profileSlice.actions;

export default profileSlice.reducer;
